module.exports = __webpack_public_path__ + "static/media/ic_proyectos_ferroviario_pin_seleccionado.37eab09c.svg";